export default __webpack_public_path__ + "static/media/scritta.4fa852c2.png";